import InitGlobal from './initGlobal';
import InitCustomizer from './initCustomizer';
import InitMain from './initMain';
import InitNavigation from './initNavigation';
import InitSwiper from './initSwiper';
import InitFooter from './initFooter';
import InitAos from './initAos';
import InitHeaderOnScroll from './initHeaderOnScroll';
import InitScrollSmoother from './initScrollSmoother';
import InitObserver from './initObserver';
import InitHasScrolled from './initHasScrolled';

const initGlobal = new InitGlobal();
const initCustomizer = new InitCustomizer();
const initNavigation = new InitNavigation();
const initFooter = new InitFooter();
const initAos = new InitAos();
const initHeaderOnScroll = new InitHeaderOnScroll();

const body = document.body;
if (body.classList.contains('home')) {
  const initSwiper = new InitSwiper();
  const initMain = new InitMain();
}
// const initScrollSmoother = new InitScrollSmoother();
// const initObserver = new InitObserxver();
// const initHasScrolled = new InitHasScrolled();
